<template>
  <div>
    <div class="content-i">
      <div class="content-box row">
        <div class="col-sm-12 col-md-12">
          <div class="element-wrapper">
            <h6 class="element-header">{{ t('manageWidgetCollectionHeader', 'manageWidgetCollectionHeader') }}</h6>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 row">
          <div class="col-md-3 col-sm-12">
            <div class="element-wrapper max-height">
              <div class="element-box">
                <h6 class="element-header">{{ t('documentsOverviewStatsWidget', 'documentsOverviewStatsWidget')}}</h6>
                <DocumentsOverviewStats></DocumentsOverviewStats>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="element-wrapper max-height">
              <div class="element-box">
                <h6 class="element-header">{{ t('portalUseStatsWidget', 'portalUseStatsWidget')}}</h6>
                <PortalUseStats></PortalUseStats>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="element-wrapper max-height">
              <div class="element-box">
                <h6 class="element-header">{{ t('batchesStatusChartWidget', 'batchesStatusChartWidget')}}</h6>
                <BatchesStatusChart></BatchesStatusChart>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="element-wrapper max-height">
              <div class="element-box">
                <h6 class="element-header">{{ t('deliveryMethodsWidget', 'deliveryMethodsWidget')}}</h6>
                <DeliveryMethodsChart></DeliveryMethodsChart>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="element-wrapper max-height">
              <div class="element-box">
                <h6 class="element-header">{{ t('electronicConversionsWidget', 'electronicConversionsWidget')}}</h6>
                <ElectronicConversionsChart></ElectronicConversionsChart>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="element-wrapper max-height">
              <div class="element-box">
                <h6 class="element-header">{{ t('documentsCountChartWidget', 'documentsCountChartWidget')}}</h6>
                <DocumentsCountChart></DocumentsCountChart>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="element-wrapper max-height">
              <div class="element-box">
                <h6 class="element-header">{{ t('emailStatsChartWidget', 'emailStatsChartWidget')}}</h6>
                <EmailStatsChart></EmailStatsChart>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <div class="element-wrapper max-height">
              <div class="element-box">
                <h6 class="element-header">{{ t('documentsPaymentsChartWidget', 'documentsPaymentsChartWidget')}}</h6>
                <DocumentsPaymentsChart></DocumentsPaymentsChart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import BatchesStatusChart from '@/components/Widgets/BatchesStatusChart.vue'
import DocumentsOverviewStats from '@/components/Widgets/DocumentsOverviewStats.vue'
import PortalUseStats from '@/components/Widgets/PortalUseStats.vue'
import DeliveryMethodsChart from '@/components/Widgets/DeliveryMethodsChart.vue'
import ElectronicConversionsChart from '@/components/Widgets/ElectronicConversionsChart.vue'
import DocumentsCountChart from '@/components/Widgets/DocumentsCountChart.vue'
import EmailStatsChart from '@/components/Widgets/EmailStatsChart.vue'
import DocumentsPaymentsChart from '@/components/Widgets/DocumentsPaymentsChart.vue'
import { VclTable } from 'vue-content-loading'

export default {
  name: 'KPI',
  components:{
    Navbar,
    BatchesStatusChart,
    DocumentsOverviewStats,
    PortalUseStats,
    DeliveryMethodsChart,
    ElectronicConversionsChart,
    DocumentsCountChart,
    EmailStatsChart,
    DocumentsPaymentsChart,
    VclTable
  }
}
</script>

<style scoped>
  .max-height {
    height: 100%;
  }
  .max-height > div {
    height: 100%;
  }
  .brand-color > tr > th {
    background-color: #047bf8 !important;
    color: white !important;
  }
</style>